import { render } from "./RouteList.vue?vue&type=template&id=36a8b825&scoped=true&lang=pug"
import script from "./RouteList.vue?vue&type=script&lang=ts"
export * from "./RouteList.vue?vue&type=script&lang=ts"

import "./RouteList.vue?vue&type=style&index=0&id=36a8b825&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-36a8b825"

export default script